export const tilePale = "rgba(255,255,255,0.08)";
